import React from 'react';
import './App.css';
import SolmazPic from './SolmazPic.jpeg';
import Topbar from './Topbar';
import Footer from './Footer';
import { motion } from 'framer-motion';
import { solmaz1 } from './TextContent.json';
import { Link } from 'react-router-dom';
import pic2 from './About2.jpg';

class Solmaz extends React.Component {
    render() {
        return (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
            >
                <Topbar />
                <div className="header-image5">
                    <div className="services1">Solmaz Barghgir</div>
                </div>
                <div className='profile-container'>
                    <div className='profile-section'>
                        <img src={SolmazPic} alt="Tracy Bertrim" className='profile-pic' />
                        <div className='profile-overview-section'>
                            <div class="profile-header">Overview</div>
                            <div className='profile-overview'>Populations Served</div>
                            <ul className='overview-list'>
                                <li>Adolescents</li>
                                <li>Adults</li>
                            </ul>
                            <div className='profile-overview'>Therapy Formats</div>
                            <ul className='overview-list'>
                                <li>Individual</li>
                                <li>Family</li>
                            </ul>
                            <div className='profile-overview'>Main Areas of Focus</div>
                            <ul className='overview-list last-list'>
                                <li>Anxiety</li>
                                <li>Relationship Issues</li>
                                <li>Self Esteem</li>
                            </ul>
                        </div>
                    </div>
                    <br />
                    <div class="profile-bio">
                        <div>
                            <p className='profile-paragraph'>{solmaz1}</p>
                            <p className='profile-paragraph'>Recognizing the importance of collaboration, Solmaz believes in the shared responsibility
                                between counsellor and client in the therapeutic journey. <i>Solmaz tailors integrated interventions
                                    to address individual needs using diverse therapeutic approaches</i> from a range of evidence-
                                based modalities, including Art Therapy, Attachment-based Coaching, Cognitive Behavioural
                                (CBT), Emotionally Focused, Multicultural, Narrative, and Solution-Focused Brief (SFBT) to
                                tailor treatment plans that would effectively soothe clients' needs.</p>
                            <p className='profile-paragraph'>**Solmaz provides  <i>virtual</i> therapy services</p>
                            <div class="services-button"><Link to='/contact' className="contact-submit contact-me">Interested in services? Click here</Link></div>
                        </div>
                        <img src={pic2} alt="image" className="image2 desktop" />
                    </div><br></br><br></br>
                </div>
                <Footer />
            </motion.div>
        )
    }
}

export default Solmaz;